
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M2.75 8.351v5.289c0 1.943 0 1.943 1.833 3.181l5.042 2.913a3.03 3.03 0 002.75 0l5.042-2.915c1.833-1.236 1.833-1.236 1.833-3.17v-5.3c0-1.934 0-1.934-1.833-3.172l-5.042-2.913a3.03 3.03 0 00-2.75 0L4.583 5.179C2.75 6.417 2.75 6.416 2.75 8.351z"}}),_c('path',{attrs:{"d":"M13.75 11A2.75 2.75 0 1111 8.25 2.75 2.75 0 0113.75 11z","opacity":".34"}})])])
          )
        }
      }
    